<template>
  <div class="staff">
    <div class="legend" aria-hidden="true">
      <span v-for="part in parts" :key="part.key"><i :style="{ background: part.color }" />{{ part.label }}</span>
    </div>
    <ul>
      <li v-for="row in rows" :key="row.id">
        <div class="row" :aria-label="summary(row)">
          <span class="name">{{ row.name }}</span>
          <span class="stack">
            <span v-for="part in parts" v-show="row[part.key]" :key="part.key" class="seg" :style="{ width: share(row[part.key]) + '%', background: part.color }"
                  @mouseenter="tip = { row, part }" @mouseleave="tip = null" />
          </span>
          <span class="total vn-num">{{ fa(row.done + row.open) }}</span>
        </div>
        <div v-if="tip && tip.row === row" class="tip" role="status"><b class="vn-num">{{ fa(row[tip.part.key]) }}</b> {{ tip.part.label }} · {{ row.name }}</div>
      </li>
      <li v-if="!rows.length" class="empty"><EmptyState kind="visits" size="sm" inline title="در این بازه ویزیتی انجام نشده" description="" /></li>
    </ul>
  </div>
</template>

<script>
import EmptyState from '@/components/EmptyState/index.vue';
import { fa } from './format';

// rows: [{ id, name, done, approved, rejected, waiting, open }]; waiting = done - approved - rejected
export default {
  name: 'StaffBars',
  components: { EmptyState },
  props: { rows: { type: Array, required: true } },
  data: () => ({
    tip: null,
    parts: [
      { key: 'approved', label: 'تأییدشده', color: 'var(--teal-500)' },
      { key: 'waiting', label: 'منتظر بررسی', color: 'var(--navy-700)' },
      { key: 'rejected', label: 'ردشده', color: 'var(--pink-500)' },
      { key: 'open', label: 'باز', color: 'var(--amber-500)' },
    ],
  }),
  computed: { max() { return Math.max(1, ...this.rows.map(row => row.done + row.open)); } },
  methods: {
    fa,
    share(value) { return (value / this.max) * 100; },
    summary(row) { return row.name + ': ' + this.parts.map(part => `${fa(row[part.key])} ${part.label}`).join('، '); },
  },
};
</script>

<style scoped>
.legend { display: flex; flex-wrap: wrap; gap: 14px; font-size: 12px; color: var(--text-2); margin-bottom: 8px; }
.legend span { display: inline-flex; align-items: center; gap: 6px; }
.legend i { width: 10px; height: 10px; transform: skewX(var(--slant)); }
ul { list-style: none; margin: 0; padding: 0; display: grid; gap: 2px; }
li { position: relative; }
.row { display: grid; grid-template-columns: minmax(110px, 34%) 1fr 48px; align-items: center; gap: 10px; min-height: 38px;
  padding: 4px 8px; border-radius: var(--r-sm); font-size: 12.5px; color: var(--text-2); }
.row:hover { background: var(--navy-50); }
.name { min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.stack { display: flex; gap: 2px; height: 12px; }
.seg { height: 100%; min-width: 4px; transition: width .3s var(--ease-out); }
.total { text-align: left; font-weight: 800; color: var(--navy-900); }
.tip { position: absolute; top: -30px; left: 56px; z-index: 3; padding: 6px 10px; border-radius: var(--r-sm); background: var(--navy-900);
  color: var(--navy-200); font-size: 12px; white-space: nowrap; pointer-events: none; box-shadow: var(--shadow-pop); }
.tip b { color: #fff; }
.empty { padding: 8px; }
</style>
